// GENERATED FILE - DO NOT MODIFY

export enum GetUsersSortColumnDto {
    Name = "Name",
    Email = "Email",
}